import React from "react";
import { FmIcon } from "..";
import { useIsMobile, useTheme } from "../../Hooks";

import useStyles from "./FmTermsPopup.style";

interface FmTermsPopupProps {
    isShow: boolean;
    setIsShow: any;
    title: string;
    description: string;
}

const FmTermsPopup = ({ isShow, setIsShow, title, description }: FmTermsPopupProps) => {
    const classes = useStyles();
    const theme = useTheme();
    const isMobile = useIsMobile();

    const onCloseHandler = () => {
        setIsShow(false);
    };

    return (
        <>
            {isShow && (
                <div className={classes.wrapper}>
                    <div className={isMobile ? classes.mobile_container : classes.container}>
                        <div className={classes.title}>{title}</div>
                        <p className={classes.description}>{description}</p>
                        <div className={classes.close_container} onClick={onCloseHandler}>
                            <FmIcon url={theme.images.whiteClose} />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default FmTermsPopup;
